import React from "react";
import TTSForm from "../../components/common/TTSForm";
import PageTitle from "../../assets/images/city-image-navigation.jpeg";
import { products } from "../../data/products";
export default function Hgs() {
  const pageImage = products.find(
    (p) => p.link === window.location.pathname
  )?.img;

  return (
    <div className="container-fluid animate pageWrapper">
      {/* <!--Page--> */}
      <div className="container-fluid animate pageWrapper">
        {/* <!--pageTitle--> */}
        <div
          className="container-fluid section pageTitle"
          style={{
            backgroundImage: `url(${PageTitle})`,
          }}
        >
          <div className="container-fluid container">
            {/* <!--Text--> */}
            <div className="row middle-xs start-xm center-xs reverse">
              <div className="col-lg-4 col-md-3 col-sm-3 col-xm-2 col-xs-12 end-xm center-xs">
                <div className="slogan"></div>
              </div>
              <div className="col-lg-8 col-md-9 col-sm-9 col-xm-10 col-xs-12 title">
                <h1>Hızlı Ge&#231;iş Sistemi (HGS)</h1>
                <span className="breadcrumbs">
                  <a href="/">Anasayfa</a> {">"} <a href="/urunler">Ürünler</a>{" "}
                  {">"} <a href="#">Hızlı Ge&#231;iş Sistemi (HGS)</a>
                </span>
              </div>
            </div>
            {/* <!--/Text--> */}
          </div>
        </div>
        {/* <!--/pageTitle--> */}
        {/* <!--page--> */}
        <div className="container-fluid section page-section">
          <div className="container-fluid container">
            {/* <!--Title--> */}
            <div className="row center-xs">
              <div className="col-lg-12 col-xs textRow">
                <h2 className="title">
                  <b>Hızlı Ge&#231;iş Sistemi (HGS)</b>
                </h2>
              </div>
            </div>
            {/* <!--/Title--> */}
            {/* <!--urunler--> */}
            <div className="row mt-3 start-sm center-xs">
              {/* <!--urun--> */}
              <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                <div className="productBox">
                  <span className="Image">
                    <img src={pageImage ?? ""} height="263" width="375" />
                  </span>
                </div>
              </div>
              {/* <!--/urun--> */}
              <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                <div className="textCapsule">
                  <h3>Shell Kurumsal HGS</h3>

                  <p>
                    <b>
                      Şirket ara&ccedil;larınızın HGS ge&ccedil;işlerini Shell
                      Taşıt Tanıma Sistemi ile birlikte y&ouml;netin, sonradan
                      &ouml;deme ve online raporlama avantajını yaşayın.
                    </b>
                  </p>

                  <h4>Hızlı Ge&ccedil;iş Sistemi (HGS):</h4>

                  <p>
                    Hızlı Ge&ccedil;iş Sistemi, boğaz k&ouml;pr&uuml;leri ve
                    otoyol ge&ccedil;işlerinde &ouml;demenin pasif uzaktan okuma
                    teknolojisi kullanılarak ger&ccedil;ekleştirildiği
                    &uuml;cretlendirme sistemidir.
                  </p>

                  <p>
                    Mevcutta Taşıt Tanıma Sistemi m&uuml;şterileri mevcut
                    hesabından HGS edinebilir ve &ouml;demelerini mevcut Shell
                    hesabından ger&ccedil;ekleştirebilir.
                  </p>

                  <h4>Shell&rsquo;den HGS almanın Avantajları:</h4>

                  <p>
                    &nbsp;&bull; &Ouml;nden bakiye y&uuml;klemeye gerek
                    kalmadan, mevcut Shell&rsquo;de tanımlı &ouml;deme
                    hesabından, HGS ge&ccedil;işlerini sonradan &ouml;deyerek,
                    nakit kullanımını daha verimli y&ouml;netilebilir.
                    <br /> &nbsp;&bull; Haftalık ge&ccedil;işlerin tamamı tek
                    faturaya yansıtılır ve anlaşılan vade s&uuml;resinin sonunda
                    tahsil edilir.
                    <br /> &nbsp;&bull; HGS ge&ccedil;işleri ve yakıt
                    t&uuml;ketimleri Shell Taşıt Tanıma Sistemi internet sitesi
                    &uuml;zerinden entegre olarak raporlanır, plaka ve filo
                    bazında analiz edilebilir.
                    <br /> &nbsp;&bull; T&uuml;m HGS ge&ccedil;işleri, Shell
                    Taşıt Tanıma Sistemi internet sitesi &uuml;zerinden
                    kolaylıkla takip edilebilir.
                    <br /> &nbsp;&bull; HGS etiket bakiyesinin tek tek takip
                    edilmesi gerekmez.
                    <br /> &nbsp;&bull; HGS etiketleri i&ccedil;in Shell TTS web
                    sitesi &uuml;zerinden talepte bulunulabilir ve etiket
                    teslimatı başvuranın adresine yapılmaktadır.
                    <br /> &nbsp;&bull; Otoyol ve k&ouml;pr&uuml;
                    ge&ccedil;işlerinde alt veya &uuml;st limit sınırlaması
                    olmadan ge&ccedil;iş yapılabilir.
                    <br /> &nbsp;&bull; Ge&ccedil;işler cezasız olacağından
                    bariyer kapanmaz. Ge&ccedil;iş ihlalinden dolayı, tanımlı
                    plakalar cezaya d&uuml;şmez.
                  </p>

                  <p>
                    <a
                      className="file"
                      href="/file/shell-corporate-hgs-brochure.pdf"
                      target="_blank"
                    >
                      Shell Kurumsal HGS Broş&uuml;r&uuml;
                    </a>
                  </p>
                </div>
              </div>
            </div>
            {/* <!--/urunler--> */}
            {/* <div className="row mt-4 center-xs">
              <div className="col-lg-12 col-xs">
                <div className="accardion">
                  <ul>
                    <li>
                      <span className="Button">HGS Nedir?</span>
                      <span className="Capsule">
                        <p>
                          Köprü ve otoyol geçişlerinde ödemenin pasif uzaktan
                          okuma teknolojisi kullanılarak gerçekleştirildiği
                          ücretledirme sistemidir. Köprü ve Otoyollardan alınan
                          geçiş ücretinin tahsili için kullanılan sisteme Hızlı
                          Geçiş Sistemi yani HGS denir. HGS etiketleri aracın ön
                          camına yapıştırılır. Bu sayede, HGS etiketine sahip
                          araçlar cezaya düşmeden köprü ve otoyollardan geçiş
                          yapabilir.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell’in sağladığı Kurumsal HGS hizmeti nedir?
                      </span>
                      <span className="Capsule">
                        <p>
                          Sektörde bir ilk olan PTT ile yaptığımız iş birliği
                          ile Shell Taşıt Tanıma Sistemi (Shell TTS) müşterileri
                          köprü ve otoban geçişlerini Shell hesabından
                          gerçekleştirerek, takibi kolay, rahat ve cezasız geçiş
                          sağlar. Kurumsal HGS hizmetinde filo araçlarının HGS
                          etiketlerini tek tek takip etmeye gerek kalmadan tüm
                          filo için geçerli olan tek bir fatura üzerinden
                          filonuzun HGS geçişlerini kolaylıkla, etiketlere
                          bakiye yüklemeden ve sonradan ödeme avantajı ile
                          ödeyebilirsiniz.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Shell’den Kurumsal HGS almanın avantajları nelerdir?
                      </span>
                      <span className="Capsule">
                        <p>
                          Firmalar için Shell’den Kurumsal HGS hizmeti almanın
                          filo yönetiminde birden fazla faydası bulunmaktadır.
                          İlk olarak; ön ödeme ile tek tek HGS bakiye
                          yüklemenize gerek kalmadığından operasyonel olarak
                          kolaylık sağlar. Ayrıca, tüm filo için geçerli olan
                          tek bir fatura üzerinden filoların HGS geçişleri
                          kolaylıkla yönetilebilir. Böylece, HGS bakiye
                          sorgulamanıza gerek kalmadan Shell Taşıt Tanıma
                          Sistemi (Shell TTS) internet sitesi üzerinden tüm HGS
                          geçişlerini kolaylıkla takip edebilirsiniz. Shell’in
                          sunduğu Kurumsal HGS ile ihlalli geçiş riski tamamen
                          ortadan kalkar, bu sayede şirket HGS masraflarının
                          daha kolay ve verimli bir şekilde yönetimini
                          yapabilirsiniz. Ek olarak, detaylı raporlama özelliği
                          ile plaka ve filo bazında şirket araçlarınızın HGS
                          geçişlerini analiz edebilirsiniz.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        Kurumsal HGS hizmetinden kimler yararlanabilir?
                      </span>
                      <span className="Capsule">
                        <p>
                          Shell Taşıt Tanıma Sistemi’ne (Shell TTS) sahip tüm
                          filolar Shell Yol Hizmetleri’nin sunduğu Kurumsal HGS
                          hizmetinden faydalanabilir.
                        </p>
                      </span>
                    </li>
                    <li>
                      <span className="Button">
                        HGS etiketleri nereden alınır?
                      </span>
                      <span className="Capsule">
                        <p>
                          Şirket araçlarının HGS etiketleri belirtilen adrese
                          teslim edilir. Böylece, ofis dışında vakit harcamaya
                          gerek kalmaz.
                        </p>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        {/* <!--/page--> */}
        {/* <!--talep-formu--> */}
        <div className="container-fluid section page-form-section">
          <div className="container-fluid container">
            {/* <!--Text--> */}
            
            {/* <!--/Text--> */}
            <TTSForm />
          </div>
        </div>
        {/* <!--/talep-formu--> */}
      </div>
      {/* <!--//Page--> */}
    </div>
  );
}
